module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Regular-6b109fecbc7563467e364a228c5106f0.ttf";